export enum BACKGROUND_ARRANGEMENT {
  CONTAIN = 'contain',
  COVER = 'cover',
  INITIAL = 'initial',
}

export enum BACKGROUND_REPEAT {
  REPEAT = 'repeat',
  NO_REPEAT = 'no-repeat',
}

export enum BACKGROUND_POSITION {
  BOTTOM = 'bottom',
  BOTTOM_LEFT = 'bottom left',
  BOTTOM_RIGHT = 'bottom right',
  CENTER = 'center',
  LEFT = 'left',
  RIGHT = 'right',
  TOP = 'top',
  TOP_LEFT = 'top left',
  TOP_RIGHT = 'top right',
}

export const arrangementOptions: Record<'value' | 'label', string>[] = [
  {
    value: BACKGROUND_ARRANGEMENT.INITIAL,
    label: __('Tile'),
  },
  {
    value: BACKGROUND_ARRANGEMENT.COVER,
    label: __('Fill'),
  },
  {
    value: BACKGROUND_ARRANGEMENT.CONTAIN,
    label: __('Fit'),
  },
];

export const positionOptions: Record<'value' | 'label', string>[] = [
  {
    value: BACKGROUND_POSITION.LEFT,
    label: __('Left'),
  },
  {
    value: BACKGROUND_POSITION.RIGHT,
    label: __('Right'),
  },
  {
    value: BACKGROUND_POSITION.TOP,
    label: __('Top'),
  },
  {
    value: BACKGROUND_POSITION.BOTTOM,
    label: __('Bottom'),
  },
  {
    value: BACKGROUND_POSITION.CENTER,
    label: __('Center'),
  },
  {
    value: BACKGROUND_POSITION.TOP_LEFT,
    label: __('Top Left'),
  },
  {
    value: BACKGROUND_POSITION.TOP_RIGHT,
    label: __('Top Right'),
  },
  {
    value: BACKGROUND_POSITION.BOTTOM_LEFT,
    label: __('Bottom Left'),
  },
  {
    value: BACKGROUND_POSITION.BOTTOM_RIGHT,
    label: __('Bottom Right'),
  },
];

export const repeatOptions = [
  {
    value: BACKGROUND_REPEAT.NO_REPEAT,
    label: __('No repeat'),
  },
  {
    value: BACKGROUND_REPEAT.REPEAT,
    label: __('Repeat'),
  },
];
